module.exports = __webpack_public_path__ + "img/Users2.388a2780.png";